const todosData = [
  {
    id: 1,
    text: 'Take a cup of hot coffee',
    completed: true,
  },
  {
    id: 2,
    text: 'Cook tasty dinner',
    completed: false,
  },
  {
    id: 3,
    text: 'Meet with friends',
    completed: false,
  },
];

export default todosData;
